export default "__VITE_ASSET__CXpB3Hcd__"